import { Routes, RouterModule }  from '@angular/router';
import { IcbComponent } from './icb.component';
import { t2tDataComponent } from './t2t/data/data.component';
import { t2tSummaryComponent } from './t2t/summary/summary.component';
import { t2tConfirmComponent } from './t2t/confirm/confirm.component';
import { t2cDataComponent } from './t2c/data/data.component';
import { t2cSummaryComponent } from './t2c/summary/summary.component';
import { t2cConfirmComponent } from './t2c/confirm/confirm.component';
import { DetailsComponent } from './detail/details.component';
import { ProgressStatusComponent } from '../progress-status/progress.component';
import { FileUploadComponent } from './file-upload/file-upload.component'; // Import the file-upload component

export const RequestsRoutes: Routes = [
    {
        path: '',
        component: IcbComponent,
        children: [
            { path: '', redirectTo: '/app/icb/dashboard', pathMatch: 'full' },
            { path: 'consumer/data', component: t2cDataComponent },
            { path: 'consumer/summary', component: t2cSummaryComponent },
            { path: 'consumer/confirm', component: t2cConfirmComponent },
            { path: 'trade/data', component: t2tDataComponent },
            { path: 'trade/summary', component: t2tSummaryComponent },
            { path: 'trade/confirm', component: t2tConfirmComponent },
            { path: 'detail/:id', component: DetailsComponent},
            { path: 'progress-status/:id', component:ProgressStatusComponent},
            { path: 'file-upload', component: FileUploadComponent } // Add this route

            
        ]
    },
];

export const icbRoutingModule = RouterModule.forChild(RequestsRoutes);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/icb/icb-routing.module.ts